import React from "react";

const Features = () => {
  const features = [
    {
      title: "Worldwide Leader",
      description:
        "GiveSendGo is trusted around the world for its simple, reliable fundraising platform.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/worldwide-leader.png",
    },
    {
      title: "Simple Setup",
      description:
        "Personalize, share and start collecting money in just minutes.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/simple-setup.png",
    },
    {
      title: "0% Platform Fee",
      description:
        "Keep more of the money you raised. We don't charge a platform fee.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/zero-fee.png",
    },
    {
      title: "Share Hope",
      description:
        "Raise money to share hope. Money is temporary Jesus is eternal.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/share-hope.png",
    },
    {
      title: "Easy Social Reach",
      description:
        "Share across multiple social platforms and mobile devices with just a couple clicks.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/easy-social-reach.png",
    },
    {
      title: "A+ Customer Service",
      description:
        "Real people writing real responses. We are standing by, waiting to help.",
      icon: "https://static2.givesendgo.com/vue/freedomfundraising/customer-service.png",
    },
  ];

  return (
    <section
      className="relative min-h-[600px] px-5 py-16 bg-cover bg-center text-white font-['Segoe_UI',sans-serif]"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1521737604893-d14cc237f11d')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[rgba(26,32,37,0.9)] to-[rgba(27,33,35,0.9)]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        {/* Heading */}
        <h1 className="flex flex-col mb-5">
          <span className="font-light text-[32px] text-white mb-1">
            The Leader in
          </span>
          <span className="font-bold text-[48px] text-white">
            Online Fundraising
          </span>
        </h1>

        {/* Divider */}
        <div className="w-[160px] h-[4px] bg-white mx-auto my-8"></div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center max-w-[280px] mx-auto text-center opacity-0 animate-[slideUp_0.6s_ease_forwards]"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-[90px] h-[90px] object-contain mb-4"
              />

              <h5 className="text-[20px] font-semibold text-white mb-2">
                {feature.title}
              </h5>

              <p className="text-[15px] text-white leading-[1.5]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Animation */}
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(40px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Features;
